import Route from '@ember/routing/route';
import ENV from 'tio-employee/config/environment';

// Public, unauthenticated route (sibling to `authenticated`, like `pslf-employer`).
// The tio-api `/u/:token` endpoint redirects human unsubscribe clicks here.
export default class UnsubscribeRoute extends Route {
  model(params: { token: string }) {
    return { token: params.token };
  }

  afterModel(model: { token: string }) {
    // Fire-and-forget: log that a human reached the explainer page so we can
    // track unsubscribe clicks. A tracking miss is acceptable and must never
    // block rendering, so we intentionally do not await this. The endpoint is
    // public and ignores auth.
    // `source=explainer_view` marks this as the page-view ping so tio-api can
    // tell it apart from an actual button click (source=explainer_button).
    // No body and no custom headers: keeps this a CORS "simple request" so it is
    // not preflighted and reaches tio-api even cross-origin. `keepalive` lets it
    // survive the page transition. We never read the response.
    void fetch(`${ENV.apiHost}/u/${encodeURIComponent(model.token)}?source=explainer_view`, {
      method: 'POST',
      keepalive: true,
    }).catch(() => {
      // best-effort logging only
    });
  }
}
